import { render, staticRenderFns } from "./right_5.vue?vue&type=template&id=e6b7ec30&scoped=true&"
import script from "./right_5.vue?vue&type=script&lang=js&"
export * from "./right_5.vue?vue&type=script&lang=js&"
import style0 from "./right_5.vue?vue&type=style&index=0&id=e6b7ec30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b7ec30",
  null
  
)

export default component.exports